// usage examples:
//
// import {getScrollTop} from './lib/utilities';
// or
// import * as Utils from './lib/utilities';

/**
 * Detect breakpoints - see https://adactio.com/journal/5429 for more info on usage
 * @return {String} - the value of breakpoint set in the CSS
 */
export function getBreakpoint() {
  return window
    .getComputedStyle(document.body, ':after')
    .getPropertyValue('content');
}

/**
 * Get scroll position
 * @return {Undefined}
 */
export function getScrollTop() {
  const doc = document.documentElement;
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
}

/**
 * Initialize Class from selector
 * @param   {string}  selector css selector to get objects
 * @param   {Class}   Class   Class to initialize
 * @param   {Object}  args  (optionnal) args to send to constructor
 * @param   {DOM}     ctx     (optionnal) root DOM element to look for items
 * @return  {array}   Initialized objects
 */
export function creator(selector, Class, args, ctx) {
  if (!selector || !Class) {
    return;
  }

  let itemsEl = null;
  const items = [];


  if (ctx) {
    itemsEl = ctx.querySelectorAll(selector);
  } else {
    itemsEl = document.querySelectorAll(selector);
  }

  for (let i = 0; i < itemsEl.length; i++) {
    if (args) {
      items.push(new Class(itemsEl[i], args));
    } else {
      items.push(new Class(itemsEl[i]));
    }
  }

  return items;
}
